export enum ActivityTabs {
  ALL_INDIVIDUAL = 'All Individual',
  MY_TEAM = 'My Team',
  ALL_TEAMS = 'All Teams',
  ALL = "All"
}
